import $ from 'jquery'
import { trace } from 'rytm-helpers'

const SCROLL_SPEED = 4000 // PX/sec
const SCROLL_TIME_OFFSET = .5 // PX/sec
const OFFSET_Y =  -55 // PX

const onScrollToClick = (e) => {
  e.preventDefault()
  const selector = e.currentTarget.dataset.scrollTo
  const target = selector ? document.querySelector(selector) : false
  if (target) {
    scrollToTarget(target, OFFSET_Y)
  }
}
// # Distance (PX) to target
const getDistanceToTarget = (target) => {
  const targetTop = target.offsetTop
  return Math.round(Math.abs(window.pageYOffset - targetTop))
}
// # Time of scroll to target animation
const getScrollToTargetTime = (target) => {
  const distance = getDistanceToTarget(target)
  return SCROLL_TIME_OFFSET + distance / SCROLL_SPEED
}
const getWindowScrollTop = () => {
  const doc = document.documentElement
  return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
}
export const getTargetTopScrollPos = (target) => {
  // return target.offsetTop
  const rect = target.getBoundingClientRect()
  return rect.top + getWindowScrollTop()
}
export const scrollToTarget = (target, offset = 0, time = null) => {
  const scrollTop = getTargetTopScrollPos(target) + offset
  time = time ? time : getScrollToTargetTime(target)
  let $page = $('html, body')
  $page.animate({ scrollTop }, time * 1000); 
}

export const initScrollTo = () => {
  $("body").on("click", "a[data-scroll-to]", onScrollToClick)
}